import { render, staticRenderFns } from "./SliderWorkoutProgramWeekCard.vue?vue&type=template&id=4e5109d3"
import script from "./SliderWorkoutProgramWeekCard.vue?vue&type=script&lang=js"
export * from "./SliderWorkoutProgramWeekCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports